import PersonModel from '@/models/person.model';
import LegalInfoModel from '@/models/legalInfo.model';

const state = {
  yandexMapSettings: {
    apiKey: '42558bac-ae7a-4a14-b84c-7404630333a4',
    lang: 'ru_RU',
  },
  locationFrom: null,
  locationTo: null,
  pickUpRange: null,
  calculated: false,
  calculateResult: null,
  availableProducts: [],
  selectedProduct: null,
  selectedExtras: [],
  selectedExtrasAll: [],
  selectedPayment: null,
  nearestServicePoints: [],
  p2pPServicePoints: [],
  pieces: [],
  orderType: null,
  selectedOrder: null,
  centerCoordinateMap: [],

  servicePoints: [],
  servicePointFrom: null,
  servicePointTo: null,

  shipperAddress: null,
  consigneeAddress: null,
  senderContacts: new PersonModel({}),
  receiverContacts: new PersonModel({}),
  noteForCourier: '',
  extraServices: [],
  deliveryType: null,
  pointToPoint: null,

  declaredValue: {
    value: 0,
    currency: {
      code: '',
    },
  },
  customDutyAmount: null,
  isCustomsDuty: false,
  insuredAmount: 0,
  onlineCardPaymentEmail: null,
  successShipmentResult: null,
  pickUpDate: null,
  pickUpAvailableTimes: null,
  pickUpAvailableWeekend: null,
  calculateResultStored: null,
  priceDiff: {
    price: false,
    transit: false,
    continue: true,
  },
  legalInfo: new LegalInfoModel({}),
  invoiceStatus: null,
  invoice: {
    type: null,
    currency: 'RUB',
    list: {},
    price: 0,
  },
  calcDeliverySet: {
    token: null,
    disabledStepTwo: false,
    disabledWalk: false,
    disabledClick: false,
    disabledCall: false,
  },
  marketingNewsletterAllowed: true,
  pointWalkDisabled: '',
};

export default state;
